import { ui } from "../store.js";
import { render } from "../shell.js";
export function installInputEvents() {
  document.addEventListener("input", (ev) => {
    const k = { "gl-q": "q", "aud-q": "audQ" }[ev.target.id];
    if (!k) return;
    ui[k] = ev.target.value;
    const pos = ev.target.selectionStart;
    render();
    const i = document.getElementById(ev.target.id);
    i.focus();
    try {
      i.setSelectionRange(pos, pos);
    } catch (e) {}
  });
}
